import { isAnalyticsEnabled } from '@pes-ui/utils';

/**
 * @typedef {object} LookupsDictionary
 * @property {object} addCartLocation
 * @property {object} addCartCTAType
 * @property {object} productLists
 * @property {object} cartActionCTA
 * @property {object} pesPageTypes
 * @property {object} virtualPageTypes
 * @property {object} virtualPageName
 * @property {object} pageTabs
 */

/**
 * @typedef {object} PesAnalytics
 * @property {LookupsDictionary} lookups
 */


/** @type {PesAnalytics} */
// eslint-disable-next-line prefer-destructuring
const pesAnalytics = window.pesAnalytics;

/**
 * @param {'addCartLocation' | 'addCartCTAType' | 'productLists'
 * | 'cartActionCTA' | 'pesPageTypes' | 'virtualPageTypes'
 * | 'virtualPageName' | 'pageTabs'} lookupKey
 * @returns {(key: string, id?: string) => string}
 */
function getLookupValueFunction(lookupKey) {
  if (!isAnalyticsEnabled()) { return (key) => key; }

  return (key, id) => {
    let value = pesAnalytics.lookups[lookupKey][key];

    if (id) {
      value = `${value.split(':')[0]}:${id}`;
    }

    return value;
  };
}

/**
 * @type {(key: 'productSelector'|'ctaBar') => string}
 */
export const getLookupValueAddCartLocation = getLookupValueFunction('addCartLocation');

/**
 * @type {(key: 'quantityControl'|'buttonSingleProduct'|'buttonGroupOfProducts') => string}
 */
export const getLookupValueAddCartCTAType = getLookupValueFunction('addCartCTAType');

/**
 * @type {(
 *  key: 'gridViewProducts'|'listViewProducts'|'recentlyViewedProducts'
 *       |'otherProductsFromSeries'|'relatedProducts'|'relatedProductsModal'
 *       |'substituteProducts'|'variants'|'comparedProducts'|'myProducts',
 *  id?: string
 * ) => string
 */
export const getLookupValueProductLists = getLookupValueFunction('productLists');

/**
 * @type {(key: 'pagination'|'modalWindow'|'tabsOnRange'|'pillsOnCart'|'allProductsBusinessLine') => string}
 */
export const getLookupValueVirtualPageType = getLookupValueFunction('virtualPageTypes');

/**
 * @type {(
 *   key: 'productSelector'|'buyOnline'|'relatedProducts'|'downloadInstallationFile'|'helpMeChoose'|'download',
 *   id?: string
 * ) => string}
 */
export const getLookupValueVirtualPageName = getLookupValueFunction('virtualPageName');

/**
 * @type {(key: 'productCartAllItems'|'productCartConfigurations'|'productCartSingleItems'
 *        |'rangeDocuments'|'rangeOverview'|'rangeProducts'|'rangeSoftwareRegistration'
 *        |'rangeUtilitiesAndFirmware') => string}
 */
export const getLookupValuePageTabs = getLookupValueFunction('pageTabs');
